export const IconTrash = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M11,0 C12.6568542,0 14,1.34314575 14,3 L15,3 C16.6568542,3 18,4.34314575 18,6 C18,6.88807388 17.6141196,7.68602056 17.0008825,8.23531632 L17,16 C17,18.209139 15.209139,20 13,20 L7,20 C4.790861,20 3,18.209139 3,16 L3.00009834,8.23619452 C2.3862919,7.68687122 2,6.88854726 2,6 C2,4.34314575 3.34314575,3 5,3 L6,3 C6,1.34314575 7.34314575,0 9,0 L11,0 Z M15,9 L5,9 L5,16 C5,17.1045695 5.8954305,18 7,18 L13,18 C14.1045695,18 15,17.1045695 15,16 L15,9 Z M15,5 L5,5 C4.44771525,5 4,5.44771525 4,6 C4,6.55228475 4.44771525,7 5,7 L15,7 C15.5522847,7 16,6.55228475 16,6 C16,5.44771525 15.5522847,5 15,5 Z M11,2 L9,2 C8.44771525,2 8,2.44771525 8,3 L12,3 C12,2.44771525 11.5522847,2 11,2 Z"
			/>
		</svg>
	);
};
